import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import fonts from '../../../themes/fonts';
import colors from '../../../themes/colors';

const styles = {
  driverBox: {
    backgroundColor: '#fff',
    padding: '20px',
  },
};

export const Text = styled(Typography)({
  fontSize: 15,
  fontFamily: fonts.Medium,
  color: colors['greyish-brown'],
});

export const Title = styled(Text)({
  fontSize: 20,
  fontFamily: fonts.Bold,
  color: colors['greyish-brown'],
});

export const Label = styled(Text)({
  fontSize: 13,
  color: colors.graySecond,
});

export const FormControl = styled(Box)({
  margin: '4px 8px',
});

export default styles;
